import React from 'react';
import { ReactComponent as WorkingCapital } from './WorkingCapitalSvg.svg';

function WorkingCapitalSvg() {
	return <WorkingCapital width="80pt" height="80pt" />;
}

export default WorkingCapitalSvg;
